import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

type DialogRef = {
    close: (data?: unknown) => void;
    afterClosed: () => Observable<unknown>;
};

export const DIALOG_REF = new InjectionToken<DialogRef>('DIALOG_REF');
